import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====

export function generateTask() {
  const n = Math.floor(Math.random() * 7) + 3;         // n ∈ [3,9]
  const r = Math.floor(Math.random() * 5) + 1;         // r ∈ [1,5]
  const a1 = Math.floor(Math.random() * 10) + 1;       // a1 ∈ [1,10]

  const Sn = (n / 2) * (2 * a1 + (n - 1) * r);

  return {
    type: "FindA1FromSumTask",
    data: { n, r, Sn, a1 }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { n, r, Sn } = data;

  return (
    <>
      <p>
        Dany jest ciąg arytmetyczny o różnicy{" "}
        <InlineMath math={`r = ${r}`} />.
      </p>
      <p>
        Suma pierwszych <InlineMath math={`n = ${n}`} /> wyrazów wynosi{" "}
        <InlineMath math={`S_n = ${Sn}`} />. Wyznacz <InlineMath math="a_1" />.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = parseFloat(userAnswer.raw);
  if (isNaN(given)) return false;

  return Math.abs(given - data.a1) < 0.01;
}

export function renderAnswer({ data }) {
  return (
    <InlineMath math={`a_1 = ${data.a1}`} />
  );
}

export function renderExplanation({ data }) {
  const { n, r, Sn, a1 } = data;

  const left = (2 * Sn) / n;
  const right = (n - 1) * r;
  const diff = left - right;

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Wzór na sumę <InlineMath math="n" /> wyrazów ciągu arytmetycznego:
      </p>
      <BlockMath math={`S_n = \\frac{n}{2} \\big( 2a_1 + (n-1)r \\big)`} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy dane i rozwiązujemy względem <InlineMath math="a_1" />:
      </p>
      <BlockMath
        math={`${Sn} = \\frac{${n}}{2} \\big( 2a_1 + (${n}-1) \\cdot ${r} \\big)`}
      />
      <BlockMath
        math={`\\frac{2 \\cdot ${Sn}}{${n}} = 2a_1 + ${right}`}
      />
      <BlockMath
        math={`${left} - ${right} = 2a_1`}
      />
      <BlockMath
        math={`${diff} = 2a_1`}
      />
      <BlockMath
        math={`a_1 = ${a1}`}
      />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`a_1 = ${userAnswer.raw}`} />;
}
